import { apiFetch } from '../utility';

const apiBase = 'stationQuotedPrice';
export const search = ({params, callback}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.search`,
			params,
			dispatch,
			callback,
		});
	};
};
